module.exports = __webpack_public_path__ + "static/img/env06.8f8438b.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/env06.png
// module id = 75
// module chunks = 4